import publicRoutes from '../../core/data/public-routes.json';

/** Pages published in only part of the languages (the French legal documents), by public path. */
const PAGE_LANGUAGES = new Map<string, readonly string[]>(
  publicRoutes.pages.flatMap((page) => (page.languages ? [[`/${page.path}`, page.languages] as const] : []))
);

/**
 * Localized path of a page in the new design. Since the October 2026
 * switch-over no page is served under /v3: every page lives at its public path.
 * A page missing from the current language links straight to the language it is
 * published in, rather than to an address that only redirects there.
 */
export function ancPath(lang: string, path: string): string {
  const languages = PAGE_LANGUAGES.get(path);
  return `/${languages && !languages.includes(lang) ? languages[0] : lang}${path}`;
}

/** Homepage of the site. */
export function ancHome(lang: string): string {
  return `/${lang}`;
}
